import decode from 'jwt-decode';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import { fetchAccounts } from 'store/api/accounts/accountsActions';
import { AccountsResponse, Token, UserResponse } from 'store/api/types';
import { fetchUserInfo } from 'store/api/user/userActions';
import { State } from 'store/state/state.types';

import { Dashboard } from './Dashboard';
import { DashboardProps } from './Dashboard.types';

const mapStateToProps = ({ auth }: State) => {
  const defaultProps = { email: '', isLogged: false, roles: [] };

  if (!auth.accessToken) {
    return defaultProps;
  }

  try {
    const token = decode<Token>(auth.accessToken);
    const expirationTime = parseInt(token.exp, 10) * 1000;

    return {
      email: token.user_name,
      isLogged: expirationTime > new Date().getTime(),
      roles: token.rolesInAccounts,
    };
  } catch (error) {
    return defaultProps;
  }
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onFetchAccounts: () => dispatch<Promise<AccountsResponse>>(fetchAccounts()),
  onFetchUser: () => dispatch<Promise<UserResponse>>(fetchUserInfo()),
});

export const DashboardContainer = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)((props: DashboardProps) => {
  if (!props.isLogged) {
    return <Redirect to="/logout" />;
  }

  return <Dashboard {...props} />;
});
